import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

import { computed, ref } from "vue";
import { assertUnreachable, isDefined } from "@/utils";
import { Condition } from "@/keyboard";
import {
  ConditionLogic,
  ConditionTypeLogic,
  isCondNot,
  isCondAnd,
  isCondOr,
  conditionTypeLogic,
} from "@/keyboard/leds";
import * as cutils from "@/keyboard/condition_utils";
import ConditionEdit from "@/components/leds/ConditionEdit.vue";
import InParens from "@/components/leds/InParens.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionLogicEdit',
  props: {
    modelValue: {},
    parentLogic: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// TODO: pass hover info to ConditionTypeButton and apply some animation
const hoverNot = ref(false);
const hoverAndOr = ref(false);

// NOTE: And/Or contain a list of conditions, this treats it in functional
// way by rendering only the head and passing the tail recursively.

// Some computed variables to avoid code repetition in template
const cond = computed(() => props.modelValue);
const inner = computed(() => cutils.inner(cond.value));
const condType = computed(() => conditionTypeLogic(cond.value));
const outerParens = computed(() =>
  cutils.outerParens(condType.value, props.parentLogic)
);
const innerParens = computed(
  // () => !isCondNot(cond.value) && isOther(cond.value, inner.value[1])
  // TODO: Inner parens are unnecessary? Verify?
  () => false
);

const onEditHead = (c?: Condition) => {
  const v = cond.value;
  if (isCondNot(v))
    //throw Error("onEditHead with Not");
    return emit("update:modelValue", c == undefined ? undefined : { Not: c });

  // console.log("edit head", v, c);

  const conds = [c, ...cutils.unwrap(v).slice(1)].filter(isDefined);
  emit(
    "update:modelValue",
    conds.length == 0 ? undefined : cutils.cleanup(cutils.wrap(v, conds))
  );
};

const onEditTail = (c?: Condition) => {
  const v = cond.value;
  if (isCondNot(v)) throw Error("onEditTail with Not");

  // console.log("edit tail", v, c);

  const head = cutils.wrap(v, [cutils.unwrap(v)[0]]);
  emit("update:modelValue", cutils.cleanup(cutils.merge(head, c)));
};

const swapLogic = () => {
  const v = cond.value;

  // Clicking on Not just removes it
  if (isCondNot(v)) return emit("update:modelValue", v.Not);

  // Because And/Or may have multiple conditions underneath we need to swap logic
  // only for the first pair of conditions (only it is rendered by this component).
  const inner = cutils.unwrap(v);
  const head = cutils.wrap(v, inner.slice(0, 1));
  const tail = cutils.wrap(v, inner.slice(1));
  const merged = cutils.merge(cutils.swap(head), cutils.cleanup(tail));

  emit("update:modelValue", cutils.cleanup(merged));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InParens, { visible: outerParens.value }, {
    default: _withCtx(() => [
      (_unref(isCondNot)(cond.value))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("button", {
              class: "btn-logic",
              onClick: swapLogic,
              onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (hoverNot.value = true)),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoverNot.value = false))
            }, " Not ", 32),
            _createVNode(ConditionEdit, {
              modelValue: cond.value.Not,
              "onUpdate:modelValue": onEditHead,
              parentLogic: condType.value
            }, null, 8, ["modelValue", "parentLogic"])
          ], 64))
        : (_unref(isCondAnd)(cond.value) || _unref(isCondOr)(cond.value))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (inner.value.length > 0)
                ? (_openBlock(), _createBlock(ConditionEdit, {
                    key: 0,
                    modelValue: inner.value[0],
                    "onUpdate:modelValue": onEditHead,
                    parentLogic: condType.value
                  }, null, 8, ["modelValue", "parentLogic"]))
                : _createCommentVNode("", true),
              (inner.value.length > 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("button", {
                      class: "btn-logic",
                      onClick: swapLogic,
                      onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (hoverAndOr.value = true)),
                      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (hoverAndOr.value = false))
                    }, _toDisplayString(_unref(isCondAnd)(cond.value) ? "And" : "Or"), 33),
                    _createVNode(InParens, { visible: innerParens.value }, {
                      default: _withCtx(() => [
                        _createVNode(ConditionEdit, {
                          modelValue: cutils.wrap(cond.value, inner.value.slice(1)),
                          "onUpdate:modelValue": onEditTail,
                          parentLogic: condType.value
                        }, null, 8, ["modelValue", "parentLogic"])
                      ]),
                      _: 1
                    }, 8, ["visible"])
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(_unref(assertUnreachable)(cond.value)), 1)
            ], 64))
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})